import { useEffect, useReducer, useRef } from "react";
import { useIntl } from "react-intl";
import { Outlet, useLocation } from "react-router-dom";
import HeaderRC from "@/components/header";
import FooterRC from "@/components/footer";
import styles from "./layout.style";
import { makeStyles } from "tss-react/mui";
import { produce } from "immer";
import withRoot from "@/withRoot";
import g_styles from "@/components/public.style";
import route_map, { need_login } from "../config/route_map";
import { useUserInfo } from "@/model/useUserInfo";
import { usePageMode } from "@/model/usePageMode";
import cookie from "@/utils/cookie";
import { useSize, useDebounce, useRequest } from "ahooks";
import service from "@/services/pagemode";
import SeoRouteSync from "@/components/SeoRouteSync";

const useStyles = makeStyles()((theme) => ({
  ...g_styles(theme),
  ...styles(theme),
}));

const initState = {
  maxWidth: 1440,
};
const reducer = produce((draft, action = { paylod: {}, type: "@@INTT" }) => {
  const { type, payload } = action;
  switch (type) {
    default:
      Object.keys(payload).map((item) => {
        draft[item] = payload[item];
      });
  }
}, initState);

function Layout(props) {
  const intl = useIntl();
  const { classes, cx } = useStyles();
  let location = useLocation();
  const [state, dispatch] = useReducer(reducer, initState);
  const { userinfo, getUserInfo } = useUserInfo();
  const { bodySize } = usePageMode();
  const ref_nav = useRef(null);

  const { loading, runAsync } = useRequest(service.ip_limit, { manual: true });
  const get_ip_limit = async () => {
    try {
      const res = await runAsync({
        payload: {},
      });
      if (
        res.code == "109109" &&
        window.location.pathname.indexOf("/401") == -1
      ) {
        window.location.href = "/401";
      }
    } catch (e) {}
  };
  useEffect(() => {
    getUserInfo();
    get_ip_limit();
  }, [location]);
  const noheader = [
    route_map.login,
    route_map.register,
    route_map.forgot,
    route_map.google_callback,
    route_map.bindgoogle,
  ].find((item) => location.pathname.indexOf(item) > -1);
  const nofooter = [
    route_map.login,
    route_map.register,
    route_map.forgot,
    route_map.google_callback,
    route_map.bindgoogle,
  ].find((item) => location.pathname.indexOf(item) > -1);

  return (
    <div className={classes.g_layout}>
      <SeoRouteSync />
      {noheader ? "" : <HeaderRC />}
      <main className={classes.g_content_box}>
        <div className={classes.g_content}>
          {noheader ? (
            <Outlet />
          ) : (
            <div className={classes.g_content_child}>
              <div className={classes.g_con}>
                <Outlet />
              </div>
            </div>
          )}
        </div>
      </main>
      {nofooter || window.voox_co ? "" : <FooterRC />}
    </div>
  );
}

export default withRoot(Layout);
